const ranking = [
  { rank: 1, title: '咒术回战', author: '芥见下下', genre: '热血战斗', hot: '本周 12.8万 阅读' },
  { rank: 2, title: '鬼灭之刃', author: '吾峠呼世晴', genre: '热血战斗', hot: '本周 11.2万 阅读' },
  { rank: 3, title: '间谍过家家', author: '远藤达哉', genre: '搞笑日常', hot: '本周 9.6万 阅读' },
  { rank: 4, title: '堀与宫村', author: 'HERO', genre: '甜宠恋爱', hot: '本周 8.3万 阅读' },
  { rank: 5, title: '关于我转生变成史莱姆这档事', author: '伏濑', genre: '异世界转生', hot: '本周 7.5万 阅读' },
  { rank: 6, title: '一人之下', author: '米二', genre: '古风仙侠', hot: '本周 6.9万 阅读' },
  { rank: 7, title: '死亡笔记', author: '大场鸫', genre: '悬疑推理', hot: '本周 6.2万 阅读' },
];

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门排行
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            本周最受欢迎漫画排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {ranking.map((r) => (
            <div
              key={r.rank}
              className={`flex items-center gap-4 py-4 px-4 rounded-lg cursor-default ${
                r.rank < ranking.length ? 'border-b border-background-200/60' : ''
              } hover:bg-background-50 transition-colors duration-200`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  rankColors[r.rank] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {r.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900">{r.title}</h3>
                  <span className="text-xs text-foreground-400">{r.author}</span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                    {r.genre}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-fire-line text-accent-500"></i>
                {r.hot}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}